import { render, staticRenderFns } from "./BotonProcesoTabValidaciones.vue?vue&type=template&id=5585f550&"
import script from "./BotonProcesoTabValidaciones.vue?vue&type=script&lang=js&"
export * from "./BotonProcesoTabValidaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports